import React, { useEffect } from "react";
import Form from "react-bootstrap/Form";
import { GLBANOTICELINK } from 'Utils/Constants';

const TermsAndConditions = ({ buttonText, isCashier }) => {

  buttonText = buttonText == null ? "submit" : buttonText;
  const styleClass = isCashier ? "cashier-termsAndConditions" : "termsAndConditions";

  const termsLabel = <div className={styleClass}>
    By clicking {buttonText.toUpperCase()}, I agree to the <a rel="noreferrer" className="link" target="_blank" href="https://www.vippreferred.com/terms-of-service">Terms & Conditions</a>, <a rel="noreferrer" className="link" target="_blank" href="https://www.vippreferred.com/privacy-policy">Privacy Notice</a>, and <a rel="noreferrer" className="link" target="_blank" href={GLBANOTICELINK}>GLBA Notice</a>.
  </div>;

  return (
    termsLabel
  );
};

export default TermsAndConditions;
